/**
 * @generated SignedSource<<177e3d1ec7a7b61b06f594cca7624740>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CalendarStatusResponse = "AfterHours" | "BeforeWorkingHours" | "DayOff" | "FocusTime" | "Holiday" | "Lunch" | "Meeting" | "Other" | "OutOfOffice" | "Weekend" | "WorkingHours" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CalendarStatus_calendarStatus$data = {
  readonly status: CalendarStatusResponse | null;
  readonly " $fragmentType": "CalendarStatus_calendarStatus";
};
export type CalendarStatus_calendarStatus$key = {
  readonly " $data"?: CalendarStatus_calendarStatus$data;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarStatus_calendarStatus">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CalendarStatus_calendarStatus",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "CalendarStatus",
  "abstractKey": null
};

(node as any).hash = "1bec600b051968f6d6c4ad2bdcf063db";

export default node;
